import { observer } from 'mobx-react-lite';

import { EmptySearchState } from '@components/empty-search-state';
import { EmptyState } from '@components/empty-state';
import { IconApplicants } from '@components/icons/applicants';

import { useStore } from 'models/Provider';

export const EmptyApplicationResult = observer(
  (props: { isFiltered?: boolean; hasSearch?: boolean }) => {
    const { isFiltered, hasSearch } = props;

    const { t } = useStore();

    if (hasSearch) {
      return <EmptySearchState hasFilters={Boolean(isFiltered)} />;
    }

    const heading = isFiltered ? t('job.applicants.empty.search') : t('job.applicants.empty');
    const message = isFiltered ? t('job.applicants.msg.search') : t('job.applicants.msg.all');
    return <EmptyState content={message} header={heading} icon={<IconApplicants />} />;
  }
);
